module.exports = __webpack_public_path__ + "img/9788994210629.b0985ec4.jpg";